import { useMutation } from "@tanstack/react-query";
import { api } from "../../../api";
import { OrgKey, OrgCategory } from "../../../generated/core-api";
import { useOrgMutationSuccess } from "./useOrgMutationSuccess";

/**
 * Hook for deprovisioning an organization
 */
export function useDeprovisionOrg() {
  const onSuccess = useOrgMutationSuccess(OrgCategory.public);

  return useMutation({
    mutationFn: async ({
      orgKey,
      verificationText,
    }: {
      orgKey: OrgKey;
      verificationText: string;
    }) => {
      return await api.deprovisionOrg(orgKey, {
        org_name_or_id_verification: verificationText,
      });
    },
    onSuccess,
  });
}
